export function isPayloadSchemaError(error) {
    return typeof error === 'object' && error !== null && 'code' in error && error.code === 'PayloadSchemaError';
}
